<template>
  <div class="">
    <b-form @submit.prevent="Isvalid">
      <b-row>
        <p class="component-heading">Items</p>
        <b-col lg="3" md="4" sm="6">
          <div class="field">
            <!-- <label>Item Name</label> -->
            <CustomDropdown placeholder="Select Item" v-model="Itemgroup.ItemName" name="Item Name" label="Item Name"
              id="Item Name" :items="items" :required-icon="true" :rules="{ required: true }" />
          </div>
        </b-col>
        <b-col lg="3" md="4" sm="6">
          <div class="field">
            <!-- <label>Quantity</label> -->
            <TextField v-model="Itemgroup.ItemQuantity" type="text" name="Quantity" label="Quantity" id="Quantity"
              placeholder="Enter QTY" clearable :required-icon="true" :rules="{ required: true, numeric: true }" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex flex-row-reverse">
          <AddButton type="submit" btnname="Add" @click="$emit('isadd')" />
        </b-col>
      </b-row>
      <EditConfirmation :Editmodel="Editmodel" @yes="addQuantity" @no="(Editmodel = false), IsClear"
        content="Item already added, Do you want to add more Quantity ?" />
    </b-form>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
  watch,
} from "vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../../components/FormComponents/DatePicker.vue";
import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import Itemservice from "../../../../../modules/Inventory/Service/ItemMasService";
import ItemCategoryservice from "../../../../../modules/Inventory/Service/CategoryService";
import PackSizeService from "../../../../../modules/Inventory/Service/PackSizeService";
import ItemCategoryMappingService from "../../../../../modules/Inventory/Service/ItemCategoryMappingService";
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import { value } from "dom7";
import { AnyCnameRecord } from "dns";
import { useForm } from "vee-validate";
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    showone: {
      type: String,
      default: "",
    },
    AddListValues: {
      type: Array,
      default: "",
    },
    showFields: {
      type: Object,
      default: true,
    },
    value: {},
    dataItems: {
      type: Object,
      default: {},
    },
    addItemData: {
      type: Array,
      default: [],
    },
    items: {
      type: <any>[Object],
      default: {},
    },
  },
  components: {
    TextField,
    CustomDropdown,
    Datepicker,
    EditConfirmation,
  },
  setup(props, { emit }) {
    const Editmodel = ref(false);
    const { t } = useI18n();
    let AddData: any = ref([]);
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    let dataItems: any = computed(() => props.dataItems);
    watch(
      () => props.dataItems,
      (newVal) => {
        debugger;
        if (newVal["IsEdit"] == 1) {
          IsEdit(newVal);
        }
      }
    );
    watch(
      () => props.addItemData,
      (newVal) => {
        debugger;
        AddData.value = newVal;
      }
    );
    let Itemgroup = reactive({
      ItemName: "",
      ItemQuantity: "",
    });
    debugger;

    let ItemData = reactive({
      ItemCategory: "",
      Itemname: "",
      BatchNo: "",
      PackSizename: "",
      UnitRate: "",
      ItemQuantity: "",
      MRP: "",
      Discount: "",
      ItemId: 0,
      IsEdit: 0,
      CategoryLableName: "",
      CategoryId: 0,
      PackageSizeLableName: "",
      PackageSizeId: 0,
      ItemLableName: "",
      Itemid: 0,
      ReOrderLevel: 0,
      HSNID: 0,
      ItemCode: "",
      HSNCode: "",
    });
    onMounted(() => {
      debugger;
      Object.assign(Itemgroup, props.value);
      update();
    });
    function update() {
      debugger;
      emit("update:modelValue", Itemgroup);
    }
    const Isvalid = handleSubmit((values) => { });
    // let data1 = react({
    //     ItemCategory1: '',
    //     Itemname1: '',
    //     BatchNo: '',
    //     PackSizename1: '',
    //     UnitRate1: '',
    //     ItemQuantity: '',
    //     MRP1: '',
    //     Discount1: '',

    //     CategoryId: 0,
    //     ItemId: 0,
    //     PackageSizeId: 0,
    //     ItemCode: '',
    //     HSNCode: '',
    // })

    // let CategoryLableName = ""
    // let Categoryid = 0
    // let PackageSizeLableName = ""
    // let PackageSizeid = 0
    // let ItemLableName = ""
    // let Itemid = 0
    // let ReOrderLevel = 0
    // let HSNID = 0
    // let ItemCode = ''
    // let HSNCode = ''

    //Category On Change
    const LoadItemName = ref({
      ITEMid: null,
      ITEMoption: [],
    });
    //Item Edit
    function IsEdit(data) {
      debugger;
      Object.keys(ItemData).forEach((key) => {
        if (data[key]) ItemData[key] = data[key];
      });
      CategoryOnChange(data.CategoryId), (ItemData.ItemId = data.ItemId);
    }
    function IsUpdate() {
      debugger;
      Object.values(AddData.value).forEach((items: any) => {
        if (items.ItemId == ItemData.ItemId) {
          Object.keys(items).forEach((key) => {
            if (ItemData[key]) items[key] = ItemData[key];
          });
        }
      });
      IsClear();

      emit("update:dataItems", {});
    }
    async function CategoryOnChange(CId) {
      debugger;
      if (CId) {
        let options: any = LoadCategoryName.value.Categoryoption.find(
          (item) => item["value"] === CId
        );
        ItemData.CategoryLableName = options["name"];
        ItemData.CategoryId = CId;
        try {
          const dataresponse = await ItemCategoryMappingService.getItemdata(
            177,
            CId
          );

          console.log(dataresponse);
          debugger;
          LoadItemName.value.ITEMoption = dataresponse["result"].map(
            (item: any) => {
              item.name = item.Name;
              item.value = item.ItemId;
              return item;
            }
          );
        } catch (error) {
          console.log(error);
        }
      }
    }

    // Load category
    const LoadCategoryName = ref({
      Categoryid: null,
      Categoryoption: [],
    });

    async function ItemCategoryname() {
      debugger;
      //let CateId = 177;
      let StoreID = "";
      const Storeid = localStorage.getItem("sessionData");
      if (Storeid) {
        StoreID = JSON.parse(Storeid).StoreId;
      }
      try {
        const dataresponse = await ItemCategoryservice.GetCategory(StoreID);

        console.log(dataresponse);
        debugger;

        LoadCategoryName.value.Categoryoption = dataresponse["result"].map(
          (item: any) => {
            item.name = item.Name;
            item.value = item.ItemCategoryId;
            return item;
          }
        );
      } catch (error) {
        console.log(error);
      }
    }

    const LoadPackSize = ref({
      //packagesizeid: null,
      packagesizeoption: [],
    });

    // Load Package Size
    async function PackSize() {
      debugger;
      try {
        const dataresponse = await PackSizeService.getlistdata();

        console.log(dataresponse);
        debugger;

        LoadPackSize.value.packagesizeoption = dataresponse["result"].map(
          (item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        console.log(error);
      }
    }

    const PackageSizeOnChange = (PId) => {
      debugger;
      //ItemData.PackageSizeLableName = PId.originalEvent.currentTarget.ariaLabel;
      if (PId) {
        let options: any = LoadPackSize.value.packagesizeoption.find(
          (item) => item["value"] === PId
        );
        ItemData.PackageSizeLableName = options["name"];
        ItemData.PackageSizeId = PId;
      }
    };

    // Item onChange
    const ItemOnChange = (ItemId) => {
      debugger;
      // input()
      // ItemData.ItemLableName = ItemId.originalEvent.currentTarget.ariaLabel;
      if (ItemId) {
        let options: any = LoadItemName.value.ITEMoption.find(
          (item) => item["value"] === ItemId
        );
        ItemData.ItemLableName = options["name"];
        ItemData.Itemid = ItemId;
        getValues(ItemId);
      }
    };

    //Show Item MRP
    async function getValues(ItemId) {
      debugger;

      const EditId = ItemId;
      const StoreId = 177;
      try {
        const data_response = await Itemservice.GetItems(EditId, StoreId, "", 0, 0, 0, 0, 0, 0);

        console.log(data_response["result"][0].MRP);

        ItemData.MRP = data_response["result"][0].MRP;
        (ItemData.ReOrderLevel = data_response["result"][0].ReOrderLevel),
          (ItemData.HSNID = data_response["result"][0].HSNID),
          (ItemData.ItemCode = data_response["result"][0].ItemCode);
        ItemData.HSNCode = data_response["result"][0].HSNCode;
        ItemData.PackageSizeId = data_response["result"][0].PackSizeId;
      } catch (error) {
        console.log(error);
      }
    }

    interface Item {
      // ItemCategory: string;
      // Itemname: string;
      // BatchNo: string;
      // PackSizename: string;
      // UnitRate: string;
      // Quantity: string;
      // MRP: string;
      // Discount: string;
    }

    // let AddData: Item[] = [];

    function IsAdd() {
      debugger;
      let itemCount: number = AddData.value.filter(
        (item) => item.ItemId == ItemData.Itemid
      ).length;
      if (itemCount > 0) {
        Editmodel.value = true;
      } else {
        AddItems();
      }
    }
    function addQuantity() {
      debugger;

      Object.values(AddData.value).forEach((item: any) => {
        if (item.ItemId === ItemData.ItemId) {
          item.ItemQuantity =
            parseFloat(item.ItemQuantity) + parseFloat(ItemData.ItemQuantity);
        }
      });
      Editmodel.value = false;
      IsClear();
      alert("Quantity Added Successfully");
    }

    async function AddItems() {
      debugger;

      let data1 = {};
      data1["ItemQuantity"] = ItemData.ItemQuantity;
      data1["CategoryId"] = ItemData.CategoryId;
      data1["ItemCategory1"] = ItemData.CategoryLableName;
      data1["ItemId"] = ItemData.Itemid;
      data1["Itemname1"] = ItemData.ItemLableName;
      data1["PackageSizeId"] = ItemData.PackageSizeId;
      data1["PackSizename1"] = ItemData.PackageSizeLableName;
      data1["BatchNo"] = ItemData.BatchNo;

      data1["UnitRate"] = ItemData.UnitRate;
      data1["ItemCode"] = ItemData.ItemCode;
      data1["HSNCode"] = ItemData.HSNCode;
      data1["HSNId"] = ItemData.HSNID;
      data1["MRP"] = ItemData.MRP;
      data1["ReOrderLevel"] = ItemData.ReOrderLevel;

      AddData.value.push(data1);
      console.log(AddData.value);
      emit("additemclick", AddData.value);

      // AddData.value = [];

      console.log(AddData.value);
      IsClear();
      alert("Item Added Successfully");
    }

    const copyinsert_data = JSON.parse(JSON.stringify(ItemData));
    const copyinsert_LoadCategoryName = JSON.parse(
      JSON.stringify(LoadCategoryName.value)
    );
    const copyinsert_LoadItemName = JSON.parse(
      JSON.stringify(LoadItemName.value)
    );

    function IsClear() {
      Object.assign(ItemData, copyinsert_data);
      // Object.assign(LoadItemName.value, copyinsert_LoadItemName);
      //LoadItemName.value.ITEMid = null;
      // ItemData.packagesizeid = null;
    }

    return {
      CategoryOnChange,
      PackSize,
      ItemCategoryname,
      LoadCategoryName,
      LoadItemName,
      ItemData,
      AddData,
      getValues,
      ItemOnChange,
      PackageSizeOnChange,
      LoadPackSize,
      AddItems,
      IsClear,
      Editmodel,
      IsAdd,
      addQuantity,
      dataItems,
      IsUpdate,
      Itemgroup,
      Isvalid,
    };
  },
  created() {
    this.ItemCategoryname(), this.PackSize();
  },
});
</script>
